import React, { useEffect, useRef } from 'react'
import { Link } from 'gatsby'
// import { throttle } from 'lodash'
import Navigation from './Navigation'

import './header.scss'

function Header() {
  const header = useRef()

  useEffect(() => {
    // window.addEventListener(
    //   'scroll',
    //   throttle(function(e) {
    //     console.log(document.body.getBoundingClientRect())
    //     if (document.body.getBoundingClientRect().y < -50) {
    //       header.current && header.current.classList.add('header--scroll')
    //     } else {
    //       header.current && header.current.classList.remove('header--scroll')
    //     }
    //   }, 200)
    // )
  }, [])

  return (
    <header className="header" id="header" ref={header}>
      <div className="header__container">
      <Link to="/">
       
       <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
width="77.000000px" height="77.000000px" viewBox="0 0 577.000000 577.000000"
preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.16, written by Peter Selinger 2001-2019
</metadata>
<g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1999 4215 c-3 -2 -54 -11 -115 -19 -117 -15 -180 -30 -231 -52 -17
-8 -38 -14 -47 -14 -9 0 -24 -4 -34 -9 -9 -5 -53 -27 -97 -48 -44 -21 -82 -40
-85 -43 -9 -9 -69 -50 -74 -50 -15 0 -164 -143 -215 -207 -62 -78 -161 -252
-161 -283 0 -7 -6 -26 -14 -43 -84 -197 -94 -560 -23 -847 7 -30 19 -68 25
-83 7 -16 12 -33 12 -38 0 -5 4 -17 9 -27 5 -9 27 -53 48 -97 21 -44 41 -82
44 -85 4 -3 9 -14 13 -25 3 -11 20 -35 36 -54 17 -18 30 -37 30 -40 0 -10 150
-162 188 -191 19 -14 40 -31 47 -37 8 -7 17 -13 21 -13 4 0 15 -7 24 -15 20
-18 194 -105 210 -105 7 0 26 -6 43 -14 79 -35 319 -75 447 -75 130 0 367 40
447 75 17 8 38 14 46 14 9 0 18 4 22 9 3 5 19 12 35 16 17 4 30 10 30 15 0 4
12 11 27 15 15 3 30 10 33 14 3 4 23 18 45 31 22 13 42 26 45 30 3 3 24 18 48
34 23 16 42 33 42 37 0 5 4 9 10 9 17 0 176 171 204 219 5 9 18 25 28 35 10
11 37 52 60 90 23 39 45 73 48 76 9 9 100 195 100 206 0 12 -31 30 -206 118
-73 36 -140 66 -151 66 -13 0 -28 -18 -48 -57 -16 -32 -31 -60 -34 -63 -3 -3
-15 -23 -26 -45 -23 -47 -57 -99 -67 -103 -5 -2 -8 -8 -8 -13 0 -33 -166 -205
-256 -266 -65 -44 -144 -83 -166 -83 -8 0 -19 -5 -24 -10 -27 -27 -266 -54
-362 -41 -127 18 -196 32 -207 42 -5 5 -15 9 -22 9 -20 0 -163 72 -163 82 0 4
-5 8 -11 8 -12 0 -14 1 -103 90 -36 35 -66 70 -66 77 0 7 -4 13 -8 13 -13 0
-78 130 -106 210 -65 189 -69 444 -10 633 10 31 21 57 25 57 4 0 10 14 14 30
4 17 10 30 15 30 4 0 10 10 14 23 10 42 123 160 212 223 41 29 160 84 182 84
10 0 22 4 27 9 10 10 80 24 195 41 30 5 105 9 167 9 106 1 112 0 119 -21 3
-12 5 -87 3 -167 l-4 -146 213 -3 214 -2 -4 307 c-3 286 -4 310 -23 338 -30
46 -61 72 -111 95 -43 18 -66 20 -314 20 -146 0 -269 -2 -271 -5z"/>
<path d="M3205 4198 c-3 -13 -4 -104 -3 -203 l3 -180 83 -3 c70 -2 82 -5 82
-20 0 -9 -18 -69 -40 -132 -22 -63 -58 -169 -80 -235 -22 -66 -44 -128 -50
-137 -5 -10 -10 -23 -10 -29 0 -6 -6 -25 -14 -42 -7 -18 -21 -52 -31 -77 -10
-25 -29 -69 -42 -98 l-24 -54 -42 8 c-23 4 -62 8 -87 8 -44 1 -45 0 -48 -31
-2 -25 -8 -33 -23 -33 -16 0 -19 7 -19 40 l0 40 -227 -1 c-227 -1 -228 -1
-153 -15 109 -21 219 -45 270 -59 25 -7 74 -20 110 -30 36 -9 77 -22 92 -27
37 -14 58 -4 58 27 0 18 5 25 20 25 17 0 20 -7 20 -40 0 -33 4 -42 23 -49 12
-5 40 -16 62 -24 182 -69 296 -125 470 -231 136 -83 146 -89 159 -99 97 -71
197 -147 220 -167 45 -38 256 -247 256 -253 0 -3 15 -21 33 -40 17 -19 66 -80
107 -135 l75 -101 222 -1 c216 0 221 0 216 20 -3 11 -1 20 5 20 12 0 6 31 -14
77 -8 17 -14 35 -14 39 0 9 -56 165 -76 211 -8 17 -14 38 -14 46 0 8 -7 28
-15 43 -8 16 -15 36 -15 45 0 8 -4 19 -9 25 -5 5 -14 25 -19 44 -6 19 -27 80
-47 135 -20 55 -39 109 -42 120 -3 11 -11 34 -19 52 -8 17 -14 37 -14 45 0 8
-4 18 -8 24 -5 5 -19 41 -31 79 -12 39 -26 79 -31 90 -12 25 -39 103 -47 130
-3 11 -11 34 -19 52 -8 17 -14 37 -14 45 0 8 -4 18 -9 24 -4 5 -20 45 -34 89
-29 87 -77 223 -95 268 -7 16 -12 32 -12 37 0 4 -7 21 -15 36 -8 16 -15 38
-15 50 0 11 -4 24 -9 30 -5 5 -14 25 -20 44 -11 38 -61 178 -79 223 -7 16 -12
37 -12 48 0 10 -4 19 -10 19 -5 0 -12 16 -16 37 -4 20 -13 48 -20 62 -8 14
-14 32 -14 39 0 7 -7 26 -15 42 l-16 30 -424 0 -425 0 -5 -22z m611 -597 c4
-19 13 -46 20 -60 8 -14 14 -33 14 -41 0 -9 4 -20 9 -25 5 -6 14 -26 19 -45 6
-19 27 -80 47 -135 20 -55 39 -109 42 -120 3 -11 11 -34 19 -52 8 -17 14 -37
14 -45 0 -8 4 -18 8 -24 5 -5 19 -40 31 -79 12 -38 26 -79 31 -90 5 -11 19
-49 31 -85 11 -36 27 -79 35 -97 8 -17 14 -35 14 -41 0 -5 7 -23 15 -38 8 -16
11 -30 5 -32 -8 -3 -99 44 -110 58 -5 6 -332 167 -365 180 -11 4 -37 15 -58
24 -21 9 -44 16 -52 16 -8 0 -30 7 -49 16 l-34 17 15 36 c8 20 20 50 27 66 22
49 65 168 72 198 3 15 10 30 15 33 5 3 9 13 9 22 0 9 7 30 15 46 8 15 15 35
15 43 0 8 6 29 14 46 11 25 58 161 92 266 7 21 32 -15 40 -58z"/>
</g>
</svg>
       </Link>
        <Navigation />
      </div>
    </header>
  )
}

export default Header
